// 30-minute per-channel cooldown on done snapshots. Mirrors the hard-coded
// interval in migration 0074's request_channel_snapshot RPC. If that
// interval ever changes server-side, this constant must move with it.
export const SNAPSHOT_COOLDOWN_MS = 30 * 60 * 1000;
